<div #tabsContainer class="tabs-container" [ngStyle]="{ width: width, 'border-bottom': borderBottom ? borderBottom : '' }">
  <div
    class="selection-pill"
    [class.visible]="pillVisible"
    [class.animated]="pillAnimated"
    [ngStyle]="{ transform: 'translateX(' + pillLeft + 'px)', width: pillWidth + 'px', backgroundColor: pillColor }"
  ></div>
  <div #tabWrapper class="tab-wrapper" *ngFor="let tab of tabList; let i = index" [ngClass]="{ disabled: tab.isDisabled }">
    <div class="flow-tab" [ngClass]="{ disabled: tab.isDisabled, selected: selectedTab === tab.title }" (click)="selectTab(tab)">
      <img *ngIf="tab.image" [src]="tab.image" [ngClass]="selectedTab === tab.title ? 'color-' + selectedColor : ''" />
      <p [ngClass]="selectedTab === tab.title ? 'p-medium' : ''" [ngStyle]="{ color: getSelectedColor(tab) }">{{ tab.title }}</p>
      <div *ngIf="tab.notification" class="notification" [ngStyle]="{ backgroundColor: getNotificationBackgroundColor(), border: '1px solid' + ' ' + getNotificationBorderColor() }">
        <p class="h4-medium" style="font-size: 12px" [ngStyle]="{ color: getNotificationTextColor() }">{{ tab.notification }}</p>
      </div>
    </div>
  </div>
</div>
